module.exports = __webpack_public_path__ + "img/client (3).7e7ce41f.jpg";